//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql.type

import com.apollographql.apollo.api.EnumType
import kotlin.Array
import kotlin.Deprecated
import kotlin.String
import kotlin.collections.List

public enum class FileCategory(
  public val rawValue: String,
) {
  EMAIL_TEMPLATES("EMAIL_TEMPLATES"),
  FUEL_SOUNDING_TABLES("FUEL_SOUNDING_TABLES"),
  MASTER_INSTRUCTIONS("MASTER_INSTRUCTIONS"),
  REPORT_TEMPLATES("REPORT_TEMPLATES"),
  CONTRACT("CONTRACT"),
  BUNKER_ACTIVITY_DOCUMENTS("BUNKER_ACTIVITY_DOCUMENTS"),
  TIMESHEET_DOCUMENTS("TIMESHEET_DOCUMENTS"),
  GARBAGE_RECORDS("GARBAGE_RECORDS"),
  AUDITS("AUDITS"),
  INSPECTIONS("INSPECTIONS"),
  OVERFUEL_CONSUMPTION_JUSTIFICATION_DOCUMENTS("OVERFUEL_CONSUMPTION_JUSTIFICATION_DOCUMENTS"),
  /**
   * Auto generated constant for unknown enum values
   */
  UNKNOWN__("UNKNOWN__"),
  ;

  public companion object {
    public val type: EnumType =
        EnumType("FileCategory", listOf("EMAIL_TEMPLATES", "FUEL_SOUNDING_TABLES", "MASTER_INSTRUCTIONS", "REPORT_TEMPLATES", "CONTRACT", "BUNKER_ACTIVITY_DOCUMENTS", "TIMESHEET_DOCUMENTS", "GARBAGE_RECORDS", "AUDITS", "INSPECTIONS", "OVERFUEL_CONSUMPTION_JUSTIFICATION_DOCUMENTS"))

    /**
     * All [FileCategory] known at compile time
     */
    public val knownEntries: List<FileCategory>
      get() = listOf(
        FileCategory.EMAIL_TEMPLATES,
        FileCategory.FUEL_SOUNDING_TABLES,
        FileCategory.MASTER_INSTRUCTIONS,
        FileCategory.REPORT_TEMPLATES,
        FileCategory.CONTRACT,
        FileCategory.BUNKER_ACTIVITY_DOCUMENTS,
        FileCategory.TIMESHEET_DOCUMENTS,
        FileCategory.GARBAGE_RECORDS,
        FileCategory.AUDITS,
        FileCategory.INSPECTIONS,
        FileCategory.OVERFUEL_CONSUMPTION_JUSTIFICATION_DOCUMENTS)

    /**
     * Returns all [FileCategory] known at compile time
     */
    @Deprecated(
      message = "Use knownEntries instead",
      replaceWith = ReplaceWith("this.knownEntries"),
    )
    public fun knownValues(): Array<FileCategory> = knownEntries.toTypedArray()

    /**
     * Returns the [FileCategory] that represents the specified [rawValue].
     * Note: unknown values of [rawValue] will return [UNKNOWN__]. You may want to update your schema instead of calling this function directly.
     */
    public fun safeValueOf(rawValue: String): FileCategory = entries.find { it.rawValue == rawValue } ?: UNKNOWN__
  }
}
